import { render, staticRenderFns } from "./ProductModelCreate.vue?vue&type=template&id=6e29ea05&"
import script from "./ProductModelCreate.vue?vue&type=script&lang=js&"
export * from "./ProductModelCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports